import React from 'react';
import { Chip } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import type { ExpiryChipProps } from './label.types';
import { getStatusChipSx } from './label.styles';

const ExpiryChip: React.FC<ExpiryChipProps> = ({
  label,
  tone,
  size = 'small',
  icon
}) => {
  const showWarningIcon = tone === 'error' || tone === 'warning';
  const resolvedIcon = icon ?? (showWarningIcon ? <WarningAmberIcon /> : undefined);

  return (
    <Chip
      label={label}
      icon={resolvedIcon as React.ReactElement | undefined}
      size="small"
      sx={getStatusChipSx(tone, size)}
      aria-label={`소비기한 ${label}`}
    />
  );
};

export default ExpiryChip;
